import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'exclamation-mark-icon',
  templateUrl: './exclamation-mark-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExclamationMarkIconComponent {}
